// Limity musí odpovídat backend/src/controllers/reclamation.js
export const MAX_FILE_SIZE = 15 * 1024 * 1024
export const MAX_TOTAL_FILES_SIZE = 40 * 1024 * 1024
export const ALLOWED_EXTENSIONS = ['xls', 'xlsx', 'doc', 'docx', 'pdf', 'png', 'jpg', 'jpeg', 'svg']

// Fotky z telefonu mají běžně 3–10 MB, pro posouzení závady stačí menší rozlišení
const COMPRESSIBLE_TYPES = ['image/jpeg', 'image/png']
const COMPRESS_FROM_SIZE = 500 * 1024
const MAX_IMAGE_DIMENSION = 2048
const JPEG_QUALITY = 0.8

export function formatFileSize(bytes) {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} kB`
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`
}

export function getExtension(fileName) {
  return fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : ''
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file)
    const image = new Image()
    image.onload = () => {
      URL.revokeObjectURL(objectUrl)
      resolve(image)
    }
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error(`Could not load image ${file.name}`))
    }
    image.src = objectUrl
  })
}

// Zmenší fotku na max. 2048 px a uloží jako JPEG. Když to nejde, vrátí původní soubor.
export async function compressImage(file) {
  if (!COMPRESSIBLE_TYPES.includes(file.type) || file.size < COMPRESS_FROM_SIZE) return file

  try {
    const image = await loadImage(file)
    const scale = Math.min(1, MAX_IMAGE_DIMENSION / Math.max(image.width, image.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(image.width * scale)
    canvas.height = Math.round(image.height * scale)

    const context = canvas.getContext('2d')
    context.fillStyle = '#fff' // průhledné PNG by jinak v JPEG zčernalo
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.drawImage(image, 0, 0, canvas.width, canvas.height)

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY))
    if (!blob || blob.size >= file.size) return file

    const name = `${file.name.replace(/\.[^.]+$/, '')}.jpg`
    return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified })
  } catch (e) {
    return file
  }
}

// Zkomprimuje nově vybrané soubory a vrátí ty, které se vejdou do limitů, spolu s důvody odmítnutí ostatních
export async function prepareAttachments(newFiles, currentFiles) {
  const accepted = []
  const errors = []
  let totalSize = currentFiles.reduce((sum, file) => sum + file.size, 0)

  for (const original of newFiles) {
    if (!ALLOWED_EXTENSIONS.includes(getExtension(original.name))) {
      errors.push(`Soubor „${original.name}“ má nepodporovaný formát. Povolené jsou fotografie (JPG, PNG) a dokumenty (PDF, Word, Excel).`)
      continue
    }

    const file = await compressImage(original)

    if (file.size > MAX_FILE_SIZE) {
      errors.push(`Soubor „${original.name}“ je příliš velký (${formatFileSize(file.size)}). Maximální velikost jednoho souboru je ${formatFileSize(MAX_FILE_SIZE)}.`)
      continue
    }
    if (totalSize + file.size > MAX_TOTAL_FILES_SIZE) {
      errors.push(`Soubor „${original.name}“ se už nevejde – všechny přílohy dohromady mohou mít nejvýše ${formatFileSize(MAX_TOTAL_FILES_SIZE)}.`)
      continue
    }

    totalSize += file.size
    accepted.push(file)
  }

  return { accepted, errors }
}
